import * as React from "react";

import { Switch } from "@replo/design-system/components/switch/Switch";
import { Tag } from "@replo/design-system/components/tag/Tag";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";

const BillingIntervalToggle = ({
  isYearly,
  setIsYearly,
  isWorkspaceOnYearlySubscription,
}: {
  isYearly: boolean;
  setIsYearly: (isYearly: boolean) => void;
  isWorkspaceOnYearlySubscription: boolean;
}) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="text-xs font-semibold">Annual discount</div>
      <Tag size="sm" variant="v2">
        Save up to 17%
      </Tag>
      <Tooltip
        content={
          isWorkspaceOnYearlySubscription
            ? "You are already on an annual Replo plan"
            : undefined
        }
        triggerAsChild
      >
        <Switch
          size="base"
          checked={isYearly}
          onCheckedChange={setIsYearly}
          disabled={isWorkspaceOnYearlySubscription}
        />
      </Tooltip>
    </div>
  );
};

export default BillingIntervalToggle;
